<script>
import { Bar } from "vue-chartjs";
import CompraAPI from "../../../../api/compra.js"

export default {
  extends: Bar,
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMax: 50,
              callback: function (value) {
                const ranges = [
                  { divider: 1e15, suffix: "P" },
                  { divider: 1e12, suffix: "T" },
                  { divider: 1e9, suffix: "G" },
                  { divider: 1e6, suffix: "M" },
                  { divider: 1e3, suffix: "k" },
                ];
                function formatNumber(n) {
                  for (let i = 0; i < ranges.length; i++) {
                    if (n >= ranges[i].divider) {
                      return (
                        (n / ranges[i].divider).toString() + ranges[i].suffix
                      );
                    }
                  }
                  return n;
                }

                return formatNumber(value);
              },
            },
          },
        ],
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: -10,
          bottom: 15,
        },
      },
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true,
        text: "",
        position: "top",
      },
    },
  }),
  mounted() {
    this.buscarAnaliseTendenciasUltimasEntradas();
  },
  methods: {
    buscarAnaliseTendenciasUltimasEntradas() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getAnaliseTendenciaGrupo(headers, this.params)
          .then((response) => {
            const {token, data: analiseTendencias} = response.data;
            localStorage.token = token;
            this.montarGrafico(analiseTendencias);
          })
          .catch(() => this.Helpers.logout())
      );
    },
    montarGrafico(dadosGrafico) {
      this.chartdata.labels = [];
      this.chartdata.datasets = [];

      this.chartdata.labels = dadosGrafico.data_solicitacao;

      this.chartdata.datasets.push({
        type: "line",
        label: "Tempo de Entrega",
        backgroundColor: "rgba(224, 224, 224,1)",
        borderColor: "rgba(0, 0, 0,0.5)",
        borderWidth: 1,
        pointRadius: 1.5,

        fill: true,
        data: dadosGrafico.tempo_ressuprimento,
        datalabels: {
          anchor: "end",
          align: "end",
          display: true,

          formatter: function (value) {
            const ranges = [
              { divider: 1e15, suffix: "P" },
              { divider: 1e12, suffix: "T" },
              { divider: 1e9, suffix: "G" },
              { divider: 1e6, suffix: "M" },
              { divider: 1e3, suffix: "k" },
              { divider: 1, suffix: " " },
            ];

            function formatNumber(n) {
              for (let i = 0; i < ranges.length; i++) {
                if (n >= ranges[i].divider) {
                  if (ranges[i].divider === 1) {
                    return (
                      (Math.round(n) / ranges[i].divider).toString() +
                      ranges[i].suffix
                    );
                  } else {
                    return (
                      (Math.round(n) / ranges[i].divider)
                        .toFixed(1)
                        .toString() + ranges[i].suffix
                    );
                  }
                }
              }
              return null;
            }

            return formatNumber(value);
          },
        },
      });

      this.renderChart(this.chartdata, this.options);
    },
  },
};
</script>
